"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "indexHotAtt",
  created: function created() {
    this.$permissions.loadPermissions('/standard');
  }
};